import { RemoveRedEye as RemoveRedEyeIcon } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { ADMINS_SMART_REPORTS_PATH } from '@/utils/constants';

export const ViewReportButton = () => {
  const { id } = useParams<{ id: string }>();

  return (
    <Button
      variant='text'
      color='secondary'
      href={`${ADMINS_SMART_REPORTS_PATH}/${id}/preview`}
      startIcon={<RemoveRedEyeIcon />}
    >
      <Typography variant='body1' sx={{ color: 'secondary' }}>
        View Report
      </Typography>
    </Button>
  );
};
